<ng-container *ngIf="initialized">

<div class="headerConteiner_V2+yU" style="background-color: rgb(0, 102, 204)">
  <header class="header_Dmg9u">
    <img
      src="/assets/collabo-portal/connect/images/logo.svg"
      width="300"
      height="35"
      alt="COLLABO Portal"
      class="logoImage_hSvWU"
      style="width: 163px; margin: 13px 0; margin-left: 20px"
    />
  </header>
</div>

<div class="step">
  <p class="step-title">新規登録</p>
  <ol class="step-list">
    <!-- ステップの表記は条件で変わるため変数を参照する。現ステップ以下のみactive表示とする -->
    <li class="step-item" [class.active]="i < stepState.currentStepNumber" *ngFor="let step of stepState.steps; let i = index;">
      <span class="step-num">{{ i + 1 }}</span>
      <span class="step-text">{{ step }}</span>
    </li>
    <li class="step-item">
      <span class="step-num"
        ><img
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjk1MzMgMS44MjI4NEMxMy4yMTU2IDEuNTYwNTEgMTMuMjE1NiAxLjEzNTE5IDEyLjk1MzMgMC44NzI4NTlDMTIuNjkwOSAwLjYxMDUyOCAxMi4yNjU2IDAuNjEwNTI4IDEyLjAwMzMgMC44NzI4NThMNS4xNzM5MSA3LjcwMjIxTDEuOTk2NzMgNC41MjUwM0MxLjczNDQgNC4yNjI3IDEuMzA5MDggNC4yNjI3IDEuMDQ2NzUgNC41MjUwM0MwLjc4NDQxNyA0Ljc4NzM2IDAuNzg0NDE3IDUuMjEyNjggMS4wNDY3NSA1LjQ3NTAyTDQuNjk4OTIgOS4xMjcxOUM0LjgyNDkgOS4yNTMxNiA0Ljk5NTc2IDkuMzIzOTQgNS4xNzM5MSA5LjMyMzk0QzUuMzUyMDcgOS4zMjM5NCA1LjUyMjkzIDkuMjUzMTYgNS42NDg5IDkuMTI3MTlMMTIuOTUzMyAxLjgyMjg0WiIgZmlsbD0iIzQ0QTJFMiIgc3Ryb2tlPSIjNDRBMkUyIiBzdHJva2Utd2lkdGg9IjAuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
          width="12"
          height="9"
          alt="finish"
      /></span>
      <span class="step-text">利用開始</span>
    </li>
  </ol>
</div>
<div class="cbpt-container">
  <div class="cbpt-container-inner">
    <p class="h1-sub">STEP {{stepState.currentStepNumber}}</p>
    <h1 class="h1">Doctors IDと連携</h1>
    <div class="bgBox">
      <img
        src="/assets/collabo-portal/connect/images/signup/logo-connect.svg"
        width="268"
        height="16"
        alt="DoctorsNext®⇔COLLABO Portal"
      />
      <div class="address">{{ email }}</div>
      <p>
        ご入力のメールアドレスはコラボポータルの提携サービス<br />「Doctors
        Next」で既に登録されています。ご登録情報を連携することにより、コラボポータルの利用が開始できます。
      </p>
      <p class="buttonWrapper-link">
        <a href="https://doctors-inc.jp/doctors-next/" target="_blank" class="text-link">Doctors Nextとは</a>
      </p>
    </div>
    <p class="textCaption">
      ご利用いただける場合は「Doctors Next」の連携規約をご確認の上Doctors
      Nextの「パスワード」を入力いただき次へお進みください。
    </p>
    <div class="scrollBox">
      <section>
        <h2 class="h2">
          外部サービスアカウント連携利用規約
        </h2>
        <h3 class="h3">
          第1条 利用規約の目的および適用
        </h3>
        <!-- eslint-disable no-irregular-whitespace -->
        <p>
          1. 外部サービスアカウント連携利用規約（以下「本規約」といいます）は、ドクターズ株式会社（以下「当社」といいます）がDoctors NEXT®︎（以下「本サービス」といいます）のサービスにおいて、他社が運営するサービス（以下「外部サービス」といいます）のアカウントを連携し、外部サービスを利用することに対して適用されるものです。外部サービスを利用する者は、本規約の内容を承認し、これに同意したものとみなされます。
        </p>
        <h3 class="h3">
          第2条 外部サービスの利用について
        </h3>
        <p>
          1. 会員は、外部サービスのアカウント登録及び利用に際して、該当する外部サービスの運営者が定める利用規約に従うものとします。<br>
          2. 会員が外部サービスにおけるアカウントの登録、管理等を行うにあたっては、全て自己の責任で行うものとし、管理不十分、使用上の過誤、第三者による使用等に起因するいかなる損害も、当社は責任を負わないものとします。
        </p>
        <h3 class="h3">
          第3条 外部サービスとの連携手続き
        </h3>
        <p>
          1. 会員が本サービスから外部サービスへの連携を行う場合、会員は次に掲げる情報の提供を承諾するものとします。<br>
          　(1) ユーザー識別子、メールアドレス、姓名、生年月日、性別<br>
          　(2) その他、外部サービスを利用する上で必要な情報<br>
          2. 会員が外部サービスから本サービスへの連携を行う場合、外部サービスに登録されている会員情報の当社への提供及び利用を承諾するものとします。<br>
          3. 当社は、外部サービスから提供された情報に含まれる個人情報を、本サービス利用規約「第5条 個人情報の取扱い」に従って適切に管理し、利用するものとします。
        </p>
        <h3 class="h3">
          第4条 外部サービス利用における責任
        </h3>
        <p>
          1. 外部サービスのアカウント及びパスワードの不正使用や第三者の使用によって生じた会員または第三者への損害については、会員が全責任を負うものとします。また、このような事由により当社が損害を受けた場合、会員は当社に対して全ての損害を賠償するものとします。<br>
          2. 会員は、外部サービスを自己の責任において利用し、その利用により生じた損害やトラブルについて、当社は一切の責任を負わないものとします。
        </p>
        <h3 class="h3">
          第5条 本規約の変更
        </h3>
        <p>
          1. 本規約は予告なく内容を変更する場合があります。変更した内容は本ページへ掲示することにより、即時効力を生ずるものとします。
        </p>
        <!-- eslint-enable no-irregular-whitespace -->
      </section>
    </div>
    <div class="passwordArea">
      <div>
        <div class="input-shoulder">
          <label for="input-password" class="input-label"
            >Doctors Nextのパスワード</label
          >
          <span class="input-require require">必須</span>
        </div>
        <input
          [(ngModel)]="password"
          id="password"
          type="password"
          data-keeper-lock-id="k-g9iarx73qnh"
        />

        <p *ngIf="errorMessages.login.password" class="text-danger mb-1">
          {{ errorMessages.login.password }}
        </p>
      </div>
    </div>
    <div data-v-452e7ff4="" class="linkWrapper">
      <a target="_blank" [href]="config.passwordResetUrl" class="text-link"
        >Doctors Nextのパスワードがご不明な方はこちら</a
      >
    </div>
    <div class="buttonWrapper">
      <button
        data-type="primary"
        data-hover-type="normal"
        data-is-full="true"
        type="button"
        class="button_C6Dbi"
        (click)="login()"
      >
        <span> 利用規約を確認して連携実行 </span>
      </button>
      <p class="buttonWrapper-link">
        <a (click)="back()" class="text-link"
          >別のメールアドレスで登録する</a
        >
      </p>
    </div>
  </div>
</div>
</ng-container>